import ModalTrainingFormModule from './containers/modalTrainingFormModule'

export {default as ModalTrainingFormModuleLayout} from './components/modalTrainingFormModuleLayout'

export default ModalTrainingFormModule
